module.exports = __webpack_public_path__ + "static/media/hogfish.d4a23eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/hogfish.png
// module id = 317
// module chunks = 0